/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Otp_TitleInputs */

const he_auth_signup_otp_title = /** @type {(inputs: Auth_Signup_Otp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השלמת הרשמה`)
};

const en_auth_signup_otp_title = /** @type {(inputs: Auth_Signup_Otp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete sign-up`)
};

/**
* | output |
* | --- |
* | "Complete sign-up" |
*
* @param {Auth_Signup_Otp_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_otp_title = /** @type {((inputs?: Auth_Signup_Otp_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Otp_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_otp_title(inputs)
	return en_auth_signup_otp_title(inputs)
});